module.exports = __webpack_public_path__ + "faf722b9d13ef55563eaf98f3351234f.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/head/AGWESER.jpg
// module id = 611
// module chunks = 0